module.exports = {
    development: {
        base_url: 'http://localhost:3000',
    },
    production: {
        base_url: 'https://forum.kevinbajzek.com',
    }
};